import { useQuery } from "@tanstack/react-query";
import { FinanceApprovalService } from "../services/FinanceApprovalService";
import { IFinanceApprovalLot } from "@shared/lib/types/finance";
import { BackednResponse } from "@shared/lib/types/response";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { FINANCE_APPROVAL_QUERY_KEY_ID } from "../constants";

export function useGetFinanceApprovalLot(lotId: string) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IFinanceApprovalLot>
  >({
    queryKey: [...FINANCE_APPROVAL_QUERY_KEY_ID(lotId)],
    queryFn: () => FinanceApprovalService.getFinanceApprovalLot(lotId),
    enabled: !!lotId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    lot: data?.data,
    isFetching: isLoading,
    isError,
  };
}
